<template>
  <div class="fill_remittance">
    <div class="top">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/remittanceRecord' }"
          >我的汇款记录</el-breadcrumb-item
        >
        <el-breadcrumb-item>新增汇款信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main">
      <el-form :model="form" :rules="rules" ref="form" class="demo-ruleForm">
        <table border="1" cellspacing="0" cellpadding="0">
          <tr>
            <td>用户名:</td>
            <td>
              <el-form-item label="" prop="username">
                <el-input
                  size="mini"
                  v-model="form.username"
                  placeholder="请输入用户名"
                ></el-input>
              </el-form-item>
            </td>
            <td rowspan="12">
              <p>
                1.客户在网络上提交的汇款信息作为我中心确认收费的辅助手段，有助于我中心加快确认首付的速度，
                但我们仍需在确认收到汇款后才能进行确认收费的操作 。
              </p>
              <p>
                2.对于已经提交过汇款信息的申请编号，或者我中心已经进行收费确认操作的申请编号，不能再次提交
                汇款信息。客户如果确认以前提交的汇款信息有误，可在备注栏加中心申请受理部门解决。如需对已经提交过汇款信息的申请编号，请编号补交款时，可在备注栏加以详细说明，或通过其他联系方式。
              </p>
              <p>
                3.使用其他客户名申请的申请编号不能提交。当次汇款包含此类申请需交费用的，请在备注栏说明或通
                过其他方式联络我中心受理申请的部门解决。
              </p>
              <p>
                4.客户提交的汇款信息在其中任何一个申请均未进行收费确认操作的情况下可以修改，但是只要我中心
                已对其中一个或多个申请进行了操作，客户将不能修改。客户确认联系我中心受理申请的部门解决。
              </p>
              <p>5.导入汇款信息和填写更多申请编号这两种方式选择其一即可。</p>
            </td>
          </tr>
          <tr>
            <td>汇款人:</td>
            <td>
              <el-form-item label="" prop="name">
                <el-input
                  size="mini"
                  v-model="form.name"
                  placeholder="请输入汇款名称"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>金额币种:</td>
            <td>
              <el-radio size="mini" v-model="form.currency" label="1"
                >人民币</el-radio
              >
              <el-radio size="mini" v-model="form.currency" label="2"
                >美元</el-radio
              >
            </td>
          </tr>
          <tr>
            <td>汇款日期:</td>
            <td>
              <el-form-item label="" prop="time">
                <el-date-picker
                  size="mini"
                  v-model="form.time"
                  type="date"
                  placeholder="请选择汇款日期"
                >
                </el-date-picker>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>联系人:</td>
            <td>
              <el-form-item label="" prop="linkman">
                <el-input
                  size="mini"
                  v-model="form.linkman"
                  placeholder="请输入联系人"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>电话:</td>
            <td>
              <el-form-item label="" prop="phone">
                <el-input
                  size="mini"
                  v-model="form.phone"
                  placeholder="请输入电话"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>邮编:</td>
            <td>
              <el-input
                size="mini"
                v-model="form.email"
                placeholder="请输入邮编"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td>地址:</td>
            <td>
              <el-input
                size="mini"
                v-model="form.area"
                placeholder="请输入地址"
              ></el-input>
            </td>
          </tr>
          <tr>
            <td>申请编号:</td>
            <td>金额:</td>
          </tr>
          <tr>
            <td>
              <el-form-item label="" prop="number">
                <el-input
                  size="mini"
                  v-model="form.number"
                  placeholder="请输入申请编号"
                ></el-input>
              </el-form-item>
            </td>
            <td>
              <el-form-item label="" prop="money">
                <el-input
                  size="mini"
                  v-model="form.money"
                  placeholder="请输入金额"
                ></el-input>
              </el-form-item>
            </td>
          </tr>
          <tr>
            <td>备注:</td>
            <td>
              <el-input
                size="mini"
                type="textarea"
                :rows="1"
                placeholder="请输入备注"
                v-model="form.remark"
              >
              </el-input>
            </td>
          </tr>
        </table>
      </el-form>

      <div class="footer">
        <el-button @click="returnBack">返回</el-button>
        <el-button type="primary" @click="submitForm('form')">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: "",
        name: "",
        currency: "",
        time: "",
        linkman: "",
        phone: "",
        email: "",
        area: "",
        number: "",
        money: "",
        remark: "",
      },
      rules: {
        name: [{ required: true, message: "请输入汇款人", trigger: "blur" }],
        time: [
          {
            type: "date",
            required: true,
            message: "请输入汇款日期",
            trigger: "change",
          },
        ],
        linkman: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        phone: [{ required: true, message: "请输入电话", trigger: "blur" }],
        number: [
          { required: true, message: "请输入申请编号", trigger: "blur" },
        ],
        money: [{ required: true, message: "请输入金额", trigger: "blur" }],
      },
    };
  },
  methods: {
    //返回
    returnBack() {
      this.$router.go(-1);
    },
    //提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert("submit!");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.fill_remittance {
  .top {
    border-bottom: 2px solid #ccc;
    padding-bottom: 10px;
  }
  .main {
    table {
      width: 100%;
      height: 200px;
      margin-top: 20px;
      border: 1px solid #eee;
      tr {
        td {
          height: 70px;
          padding: 0 15px;
          p {
            margin: 20px;
            line-height: 20px;
          }
          /deep/ .el-form-item {
            margin-bottom: 0 !important;
          }
          /deep/ .el-form-item__error {
            padding-top: 0 !important;
          }
        }
        td:first-of-type {
          width: 30%;
        }
        td:nth-of-type(2) {
          width: 30%;
        }
      }
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>